/* eslint-disable @typescript-eslint/no-explicit-any */
import { TTheme } from '@/components/ui/type'
import ReactDataTable, {
  TableColumn,
  TableProps,
  TableStyles,
  createTheme,
} from 'react-data-table-component'

createTheme(
  'solarized',
  {
    text: {
      primary: '#1b2e4b',
    },
    background: {
      default: 'transparent',
    },
    divider: {
      default: '#485e9029',
    },
  },
  'dark',
)

createTheme(
  'solarizedDark',
  {
    text: {
      primary: '#ffffff',
    },
    background: {
      default: 'transparent',
    },
    divider: {
      default: '#485e9029',
    },
  },
  'dark',
)

interface IProps extends TableProps<any> {
  data: any[]
  columns: TableColumn<any>[]
  theme?: TTheme
  pagination?: boolean
  paginationPerPage?: number
  paginationRowsPerPageOptions?: number[]
  customStyles: TableStyles
}

const DataTable = ({
  data,
  columns,
  theme,
  customStyles,
  pagination,
  paginationPerPage,
  paginationRowsPerPageOptions,
  ...rest
}: IProps) => {
  return (
    <ReactDataTable
      theme={theme === 'dark' ? 'solarizedDark' : 'solarized'}
      columns={columns}
      data={data}
      customStyles={customStyles}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      pagination={pagination}
      {...rest}
    />
  )
}

export default DataTable
